import 'intersection-observer';

const SELECTOR = 'data-lazy-script';

export function lazyScript(offset = '300px') {
  const targets = document.querySelectorAll(`[${SELECTOR}]`);
  const options = {
    root: null,
    rootMargin: `0px 0px ${offset} 0px`,
  };

  const io = new window.IntersectionObserver(handleIntersection, options);
  targets.forEach(node => io.observe(node));

  function handleIntersection(entries) {
    entries.forEach(entry => {
      const {target, intersectionRatio} = entry;

      if (intersectionRatio > 0) {
        replaceNodeWithScript(target);
        io.unobserve(target);
      }
    });
  }
}

export function replaceNodeWithScript(node) {
  const attributes = node.attributes;
  const src = node.dataset.src;
  const script = document.createElement('script');

  if (!src) {
    return;
  }

  script.src = src;

  for (let i = 0; i < attributes.length; i++) {
    const attr = attributes[i];

    if (attr.name !== SELECTOR) {
      script.setAttribute(attr.name, attr.value);
    }
  }

  node.replaceWith(script);
}
